// utils/productMergeSucios.js — P3-1 (bug 1.1, medido en e2e A5): la ficha
// NUNCA pisa un campo con cambios sin guardar. Cuando la ficha se relee (tras
// una escritura propia como el alta de variación, o por una actualización que
// llega de la tienda vía SSE), el form nuevo se FUSIONA con el actual: los
// campos SUCIOS (editados y no guardados) conservan lo del usuario; los
// limpios toman lo fresco. Funciones PURAS — las fija productMergeSucios.test.js
// por mutación.

// Claves del form ligadas a la descripción guiada: si CUALQUIERA está sucia,
// se conservan TODAS (la plantilla recompone `description` desde las partes;
// mezclar partes del usuario con un description fresco las desincroniza).
export const CLAVES_DESCRIPCION = ['description', 'descParrafo', 'descDetalles', 'descCierre'];

export function hayDescripcionSucia(sucios) {
  return CLAVES_DESCRIPCION.some((k) => sucios.has(k));
}

// Fusiona el form FRESCO (de Woo) con el ACTUAL: lo sucio gana.
// `sucios` es un Set de claves del form (name, shortDescription, images, …).
export function fusionarFormConSucios(fresco, actual, sucios) {
  const out = { ...fresco };
  const conservar = new Set(sucios);
  if (hayDescripcionSucia(sucios)) CLAVES_DESCRIPCION.forEach((k) => conservar.add(k));
  for (const k of conservar) {
    if (k in actual) out[k] = actual[k];
  }
  return out;
}

// Fusiona las filas EDITABLES de la tabla de variaciones: la lista fresca
// manda (altas aparecen, borradas desaparecen), pero una fila que el usuario
// tocó conserva SUS campos tocados (valor + marca de tocado, para que el
// próximo Guardar los lleve).
export function fusionarVRowsConSucios(frescas, actuales) {
  const porId = new Map((actuales || []).map((r) => [r.id, r]));
  return (frescas || []).map((fila) => {
    const previa = porId.get(fila.id);
    if (!previa || !previa.tocados) return fila;
    const claves = Object.keys(previa.tocados).filter((k) => previa.tocados[k]);
    if (!claves.length) return fila;
    const out = { ...fila, tocados: { ...fila.tocados } };
    claves.forEach((k) => {
      out[k] = previa[k];
      out.tocados[k] = true;
    });
    return out;
  });
}
